export const messages = {
  en: {
    resourceEnterManage: {
      page: {
        title: 'Purchase Inbound',
        subtitle: 'Confirm purchase quantities, prices and suppliers',
        empty: 'No inbound items found'
      },
      orderId: 'Order ID',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      itemStock: 'Item Stock',
      referencePrice: 'Reference Price',
      applyQuantity: 'Apply Quantity',
      purchaseQuantity: 'Purchase Quantity',
      purchaseQuantityPlaceholder: 'Required, please enter purchase quantity',
      purchasePrice: 'Purchase Price',
      purchasePricePlaceholder: 'Required, please enter purchase price',
      supplier: 'Supplier',
      selectSupplier: 'Please select',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      submit: 'Submit',
      selectItemError: 'Please select items to enter',
      purchaseQuantityError: 'Purchase quantity is required and must be positive',
      purchasePriceError: 'Purchase price is required and must be positive',
      submitSuccess: 'Operation successful',
      submitError: 'Operation failed'
    }
  },
  zh: {
    resourceEnterManage: {
      page: {
        title: '采购入库',
        subtitle: '确认采购数量、单价与供应商',
        empty: '暂无入库物品'
      },
      orderId: '单号',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      itemStock: '物品库存',
      referencePrice: '参考单价',
      applyQuantity: '申请数量',
      purchaseQuantity: '采购数量',
      purchaseQuantityPlaceholder: '必填，请填写采购数量',
      purchasePrice: '采购单价',
      purchasePricePlaceholder: '必填，请填写采购单价',
      supplier: '供应商',
      selectSupplier: '请选择',
      remark: '备注',
      remarkPlaceholder: '可填，请填写备注',
      submit: '提交',
      selectItemError: '请选择入库物品',
      purchaseQuantityError: '采购数量未填写或填写不正确',
      purchasePriceError: '单价未填写或填写不正确',
      submitSuccess: '操作成功',
      submitError: '操作失败'
    }
  }
}